export default __webpack_public_path__ + "static/media/arrow-breadcrumbs.fd845d06.svg";